import Entity from '../entity'

export default class Address extends Entity<number>{
    wxUserId: number  = null;
    userId: string  = null;
    userName: string  = null;
    postalCode: string  = null;
    provinceName: string  = null;
    cityName: string  = null;
    countyName: string  = null;
    detailInfo: string  = null;
    telNumber: string  = null;
    isDefault: boolean;
    tenantId: number  = null;
    remark: string  = null;
}